<template>
  <div class="rate-template">
    <div class="con">
      <div
        class="Files-top"
        style="display: flex;align-items: center;justify-content: space-between;"
      >
        <div class="ic-left">
          <span>费率模板</span>
        </div>
        <div class="btns">
          <el-button
            type="primary"
            @click="addFun"
            class="last-el-button"
            v-show="newAdd"
            >新增模板</el-button
          >
          <el-button
            type="primary"
            @click="tongyi"
            v-show="!newAdd && !detailsDisable"
            >完成配置</el-button
          >
          <!-- 返回列表 -->
          <el-button
            type="primary"
            @click="listBtnFun"
            v-show="!newAdd"
            class="last-el-button"
            >返回列表</el-button
          >
        </div>
      </div>
      <div class="home-table" v-show="newAdd">
        <div class="search-input-btn" style="width:100%">
          <div class="input-small">
            <span>名称：</span>
            <el-input
              v-model="tempName"
              clearable
              placeholder="请输入名称"
            ></el-input>
          </div>
          <el-button type="primary" plain @click="searchFun" class="search-btn"
            >查询</el-button
          >
        </div>

        <div class="mytable">
          <el-table
            id="demo"
            :max-height="heights"
            border
            stripe
            :data="
              temDate.filter(
                (res) => !tempName || res.temName.includes(tempName)
              )
            "
            style="width: 100%"
          >
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据" />
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column label="序号" width="60" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="temName" label="模板名称"> </el-table-column>
            <el-table-column label="能源类型">
              <template slot-scope="scope"
                ><span>{{ scope.row.energyType | energyType }}</span></template
              >
            </el-table-column>
            <el-table-column prop="intervalTotal" label="区间数量">
            </el-table-column>
            <el-table-column label="启用" align="center" width="170">
              <template #default="{row}">
                <el-switch
                  v-model="row.dataStatus"
                  active-color="#52A1FF"
                  @change="changeFun(row.dataStatus, row.id)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" width="300">
              <template slot-scope="scope"
                ><span>{{ scope.row.createTime | date_format }}</span></template
              >
            </el-table-column>
            <el-table-column label="操作" align="center" width="250">
              <template #default="{row}">
                <div
                  style="display: flex;justify-content: center; align-items: center;"
                >
                  <span style="color:#368ED9" @click="viewDetailsFun(row.id)"
                    >详情</span
                  >
                  <span class="line"></span>
                  <span style="color:#FF1D1D" @click="delOpen(row.id)"
                    >删除</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="tem-configure" v-show="!newAdd">
        <!-- 步骤条 -->
        <div class="steps">
          <!-- 模板名称 -->
          <div class="steps-color steps-con steps-active">
            <img
              src="../../assets/rateTemplate/勾.png"
              v-if="stepNum >= 2"
            /><span class="circle circle-active" v-if="stepNum == 1">1</span
            >模板名称
            <!-- <img src="../../assets/rateTemplate/勾.png"> 模板名称 -->
          </div>
          <div
            :class="[
              'steps-line',
              'steps-line1',
              { 'steps-line-active': stepNum >= 2 },
            ]"
          ></div>
          <!-- 区间设置 -->
          <div
            :class="[
              'steps-middle',
              'steps-con',
              { 'steps-color': stepNum >= 2 },
            ]"
          >
            <img
              src="../../assets/rateTemplate/勾.png"
              v-if="stepNum >= 3"
            /><span
              :class="['circle', { 'circle-active': stepNum >= 2 }]"
              v-if="stepNum <= 2"
              >2</span
            >区间设置
          </div>
          <div
            :class="[
              'steps-line',
              'steps-line2',
              { 'steps-line-active': stepNum >= 3 },
            ]"
          ></div>
          <!-- 尖峰平谷配置 -->
          <div
            :class="[
              'steps-right',
              'steps-con',
              { 'steps-color': stepNum >= 3 },
            ]"
          >
            <span :class="['circle', { 'circle-active': stepNum >= 3 }]">3</span
            >尖峰平谷配置
          </div>
        </div>
        <!-- v-show="doneBtn" -->

        <!-- 内容 -->
        <div class="content">
          <div class="left-name">
            <div class="main">
              <div class="main-input name-top">
                <span> 模板名称： </span
                ><el-input
                  size="medium"
                  placeholder="请输入名称"
                  suffix-icon="el-icon-edit"
                  v-model.trim="addName"
                  @change="addNameFun"
                  :disabled="detailsDisable"
                ></el-input>
              </div>
              <div class="main-input type">
                <span> 能源类型： </span>
                <el-select
                  v-model="rateType"
                  placeholder="请选择"
                  :disabled="detailsDisable"
                >
                  <el-option
                    v-for="item in rateOptions"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <!-- <el-button type="primary" :disabled='isDisabled || detailsDisable' @click="nextFun">下一步</el-button> -->
            </div>
          </div>
          <div class="section">
            <div class="main" v-show="stepNum >= 2">
              <div class="main-top">
                <div class="num">
                  月区间数：
                  <el-select
                    v-model="MonValue"
                    placeholder="请选择"
                    :disabled="detailsDisable"
                  >
                    <el-option
                      v-for="item in MonOpyios"
                      :key="item.id"
                      :label="item.id"
                      :value="item.num"
                      :disabled="item.disabled"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="main-table">
                <table class="table">
                  <thead>
                    <tr>
                      <td scope="col" style="width:1.2rem">区间名称</td>
                      <td scope="col" style="width:1.6rem">开始（月）</td>
                      <td scope="col" style="width:1.6rem">结束（月）</td>
                      <td scope="col" style="width:1.2rem">尖峰平谷</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in monthTable" :key="index">
                      <td scope="row">月区间{{ index + 1 }}</td>
                      <td>{{ item.startMonth }}</td>
                      <td>
                        <el-select
                          v-model="item.endMonth"
                          placeholder="请选择"
                          @change="endChange(index)"
                          :disabled="detailsDisable"
                        >
                          <el-option
                            v-for="endItem in endMonthList"
                            :key="endItem.id"
                            :label="endItem.id"
                            :value="endItem.num"
                            :disabled="endItem.disabled"
                          >
                          </el-option>
                        </el-select>
                      </td>
                      <td
                        :class="['click', { active: peakIndex == index }]"
                        @click="disposeFun(index, 1)"
                        v-if="!detailsDisable"
                      >
                        <img
                          src="../../assets/rateTemplate/peizhi.png"
                          alt=""
                          v-show="peakIndex == index"
                        />
                        <img
                          src="../../assets/rateTemplate/未配置.png"
                          alt=""
                          v-show="peakIndex != index"
                        />点击配置
                      </td>
                      <td
                        :class="['click', { active: peakIndex == index }]"
                        v-if="detailsDisable"
                        @click="seeDetails(index)"
                      >
                        <img
                          src="../../assets/rateTemplate/peizhi.png"
                          alt=""
                          v-show="peakIndex == index"
                        />
                        <img
                          src="../../assets/rateTemplate/未配置.png"
                          alt=""
                          v-show="peakIndex != index"
                        />查看详情
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="custom-week">
                <div class="week-con">
                  <div class="week-left" style="width:1.2rem">
                    <p style="margin-right:5px">自定义</p>
                    <el-checkbox
                      v-model="weekChecked"
                      :disabled="!stepTwo"
                      @change="weekChecked_fn"
                    ></el-checkbox>
                  </div>
                  <div class="week-select">
                    <el-select
                      v-model="weekNum"
                      clearable
                      placeholder="请选择"
                      @change="weekSelect"
                      v-show="weekChecked"
                      :disabled="detailsDisable"
                    >
                      <el-option
                        v-for="item in weekData"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    :class="[
                      'click',
                      'newclick',
                      { active: peakIndex == monthTable.length },
                    ]"
                    @click="disposeFun(monthTable.length, 0)"
                    v-if="!detailsDisable && weekChecked"
                  >
                    <img
                      src="../../assets/rateTemplate/peizhi.png"
                      alt=""
                      v-show="peakIndex == monthTable.length"
                    />
                    <img
                      src="../../assets/rateTemplate/未配置.png"
                      alt=""
                      v-show="peakIndex != monthTable.length"
                    />点击配置
                  </div>
                  <div
                    :class="[
                      'click',
                      'newclick',
                      { active: peakIndex == monthTable.length },
                    ]"
                    v-if="detailsDisable && weekChecked"
                    @click="seeDetails2()"
                  >
                    <img
                      src="../../assets/rateTemplate/peizhi.png"
                      alt=""
                      v-show="peakIndex == monthTable.length"
                    />
                    <img
                      src="../../assets/rateTemplate/未配置.png"
                      alt=""
                      v-show="peakIndex != monthTable.length"
                    />查看详情
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="configure">
            <div class="main" v-show="stepNum >= 3">
              <div class="section-item">
                <div class="main-name">区间名称：{{ sectionName }}</div>
                <div class="main-table">
                  <table class="table">
                    <thead>
                      <tr>
                        <td scope="col" style="width:140px">费率类型</td>
                        <td scope="col" style="width:140px">费率值</td>
                        <td scope="col" style="width:180px">开始时间</td>
                        <td scope="col" style="width:180px">结束时间</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in peakTable" :key="index">
                        <td scope="row" class="type">
                          <el-select
                            v-model="item.stageType"
                            placeholder="请选择"
                            :disabled="detailsDisable"
                            @change="stageTypeFun(item.stageType, index)"
                          >
                            <el-option
                              v-for="k in rateTypeOption"
                              :key="k.id"
                              :label="k.label"
                              :value="k.id"
                            >
                            </el-option>
                          </el-select>
                        </td>
                        <td class="rate-num">
                          <input
                            type="text"
                            v-model.trim="item.rateValue"
                            placeholder="请输入"
                            :disabled="detailsDisable"
                          />
                        </td>
                        <td class="timer">
                          <el-select
                            v-model="item.startValue"
                            placeholder="请选择"
                            @change="timeStarChange(index)"
                            :disabled="detailsDisable"
                          >
                            <el-option
                              v-for="i in startOptions"
                              :key="i.startValue"
                              :label="i.startFrame"
                              :value="i.startValue"
                              :disabled="i.disabled"
                            ></el-option>
                          </el-select>
                        </td>
                        <td class="timer">
                          <el-select
                            v-model="item.endValue"
                            placeholder="请选择"
                            @change="timeEndChange(index)"
                            :disabled="detailsDisable"
                          >
                            <el-option
                              v-for="i in endOptions"
                              :key="i.endValue"
                              :label="i.endFrame"
                              :value="i.endValue"
                              :disabled="i.disabled"
                            ></el-option>
                          </el-select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- 添加按钮跟完成 -->
              <div class="main-btn">
                <div class="btn">
                  <div class="add" @click="peakBtnFun" v-show="!detailsDisable">
                    +
                  </div>
                </div>
                <div class="reset">
                  <el-button
                    type="warning"
                    style="margin-top:16px;width:76px"
                    @click="resetFun"
                    v-show="!detailsDisable"
                    >重置</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  rateSaveAll,
  getRateData,
  getRateRemoById,
  getRateEditEnableAndDisabled,
  getRateTimeConfig,
  getRateStageSave,
  getRateSectionSave,
  getRateFindListBySectionId,
  getRateFindSectionListByTemId,
  getRateTemSave,
} from "../../api/rateTemplate";

export default {
  data() {
    return {
      heights: Math.round(document.getElementById("app").clientHeight * 0.74), //屏幕高度 - 导航栏高度
      weekName: false,
      weekChecked: false,
      weekNum: "",
      checked: true, //自定义周
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
      ],
      weekData: [
        {
          name: "星期日",
          value: "SUNDAY",
        },
        {
          name: "星期一",
          value: "MONDAY",
        },
        {
          name: "星期二",
          value: "TUESDAY",
        },
        {
          name: "星期三",
          value: "WEDNESDAY",
        },
        {
          name: "星期四",
          value: "THURSDAY",
        },
        {
          name: "星期五",
          value: "FRIDAY",
        },
        {
          name: "星期六",
          value: "SATURDAY",
        },
      ],
      maskFlag: true, //遮罩层
      value: "",
      // 新增模板能源类型
      rateOptions: [
        {
          id: "ELECTRIC",
          label: "电",
        },
        {
          id: "WATER",
          label: "水",
        },
        {
          id: "GAS",
          label: "气",
        },
      ],
      detailsDisable: false, //查看详情禁用全部
      tempName: "", //搜索框
      inputFlag: false, //输入框样式
      //首页费率模板数据
      temDate: [
        {
          id: 302369042860033,
          createUser: "1051231df55d44b38195318a54ce12ec",
          createTime: 1700459010000,
          updateTime: 1700459010000,
          dataStatus: true,
          temName: "1",
          energyType: "ELECTRIC",
          intervalTotal: 2,
        },
        {
          id: 259552626448385,
          createUser: "1051231df55d44b38195318a54ce12ec",
          createTime: 1679552556000,
          updateTime: 1679552556000,
          dataStatus: true,
          temName: "越南模板",
          energyType: "ELECTRIC",
          intervalTotal: 2,
        },
        {
          id: 257055411572737,
          createUser: "1051231df55d44b38195318a54ce12ec",
          createTime: 1678333213000,
          updateTime: 1678333213000,
          dataStatus: true,
          temName: "越南模板1",
          energyType: "ELECTRIC",
          intervalTotal: 2,
        },
        {
          id: 253180517109761,
          createUser: "1051231df55d44b38195318a54ce12ec",
          createTime: 1676441175000,
          updateTime: 1676441175000,
          dataStatus: true,
          temName: "广东省通用模板",
          energyType: "ELECTRIC",
          intervalTotal: 1,
        },
      ],
      newListData: null, //筛选搜索关键字
      inputCheck: true, //查看全部复选框
      newAdd: true, //新增模板
      addName: "", //新增模板名称
      rateType: "", //能源类型
      stepNum: 1, //下一步
      isDisabled: false, //按钮是否禁用
      //月区间数
      MonOpyios: [
        {
          id: 1,
          num: 1,
          disabled: false,
        },
        {
          id: 2,
          num: 2,
          disabled: false,
        },
        {
          id: 3,
          num: 3,
          disabled: false,
        },
        {
          id: 4,
          num: 4,
          disabled: false,
        },
        {
          id: 5,
          num: 5,
          disabled: false,
        },
        {
          id: 6,
          num: 6,
          disabled: false,
        },
        {
          id: 7,
          num: 7,
          disabled: false,
        },
        {
          id: 8,
          num: 8,
          disabled: false,
        },
        {
          id: 9,
          num: 9,
          disabled: false,
        },
        {
          id: 10,
          num: 10,
          disabled: false,
        },
        {
          id: 11,
          num: 11,
          disabled: false,
        },
        {
          id: 12,
          num: 12,
          disabled: false,
        },
      ],
      MonValue: 1,
      //月区间结束月份下拉框
      endMonthList: [
        {
          id: 1,
          num: 1,
          disabled: false,
        },
        {
          id: 2,
          num: 2,
          disabled: false,
        },
        {
          id: 3,
          num: 3,
          disabled: false,
        },
        {
          id: 4,
          num: 4,
          disabled: false,
        },
        {
          id: 5,
          num: 5,
          disabled: false,
        },
        {
          id: 6,
          num: 6,
          disabled: false,
        },
        {
          id: 7,
          num: 7,
          disabled: false,
        },
        {
          id: 8,
          num: 8,
          disabled: false,
        },
        {
          id: 9,
          num: 9,
          disabled: false,
        },
        {
          id: 10,
          num: 10,
          disabled: false,
        },
        {
          id: 11,
          num: 11,
          disabled: false,
        },
        {
          id: 12,
          num: 12,
          disabled: false,
        },
      ],
      // 月区间数据模板
      copyMonth: null,
      // 月区间表格数据
      monthTable: [
        {
          startMonth: 1, // 开始
          //结束月份
          endMonthList: "",
          endMonth: "",
        },
      ],
      // 月区间表格数据
      monthTable2: [
        {
          startMonth: 1,
          //结束月份
          endMonthList: "",
          endMonth: "",
        },
      ],
      // 月区间数据模板
      sectionTem: [
        {
          startMonth: "待选择",
          //结束月份
          endMonthList: "",
          endMonth: "",
        },
      ],
      sectionData: null, //接口返回区间数据
      keepBtn: false, //判断是否保存区间
      addSave: null, // 新增模板返回数据
      // 尖峰平谷
      sectionName: "月区间1", // 尖峰平谷名称
      sectionId: "", // 尖峰平谷区间id
      peakFlag: false, // 判断是否保存尖峰平谷配置
      peakIndex: 0,
      // 尖峰平谷表格数据
      rateTypeOption: [
        {
          id: "STAGE_ONE",
          label: "尖",
        },
        {
          id: "STAGE_TWO",
          label: "峰",
        },
        {
          id: "STAGE_THREE",
          label: "平",
        },
        {
          id: "STAGE_FOUR",
          label: "谷",
        },
      ],
      //尖峰平谷开始时间
      startOptions: [],
      //尖峰平谷结束时间
      endOptions: [],
      peakTable: [
        {
          rateValue: "",
          stageType: "",
          startValue: "",
          endValue: "",
          startFrame: "",
          endFrame: "",
        },
      ],
      //尖峰平谷表格数据模板（拷贝用）
      copyPeakTable: null,
      // 模板
      peakTem: [
        {
          startOptions: [],
          endOptions: [],
          rateValue: "",
          stageType: "",
          startValue: "",
          endValue: "",
          startFrame: "",
          endFrame: "",
        },
      ],
      peakTem1: [
        {
          startOptions: [],
          endOptions: [],
          rateValue: "",
          stageType: "",
          startValue: "",
          endValue: "",
          startFrame: "",
          endFrame: "",
        },
      ],
      startTimeVal: "", // 开始值
      endTimeVal: "", //结束值
      startDelIndex: null, //开始删除下标
      endDelIndex: null, // 结束删除下标
      doneBtn: false, //完成配置按钮
      saveAllData: {}, //统一保存数据
      abcd: [],
      stepTwo: false,
      configure: true,
    };
  },
  created() {
    this.getRateDataFun(); //费率模板数据
    // this.getRateTimeConfigFun();//尖峰平谷时间配置
    // this.monthTable[0].endMonthList = this.endMonthList
  },
  mounted() {},
  methods: {
    // 转换启用禁用
    tranStatus(data) {
      data.forEach((item) => {
        if (item.dataStatus == "ENABLE") {
          item.dataStatus = true;
        } else {
          item.dataStatus = false;
        }
      });
    },
    //操作提醒
    operationFun(types, describe) {
      this.$message({
        type: types,
        message: describe,
      });
    },
    // 费率模板数据
    getRateDataFun() {
      getRateData()
        .then((data) => {
          this.temDate = data.data;
          this.maskFlag = false;
          this.tranStatus(this.temDate);
        })
        .catch(() => {
          this.maskFlag = false;
        });
    },
    //查询
    searchFun() {
      //判断输入框是否为空
      if (this.tempName == "") {
        this.operationFun("warning", "输入框内容不能为空");
        return;
      }
      this.inputCheck = false;
      getRateData({ temName: this.tempName }).then((data) => {
        this.temDate = data.data;

        //转换启用跟禁用
        this.tranStatus(this.temDate);
      });
    },
    //启用禁用状态改变
    changeFun(val, ids) {
      //true 启用
      if (val) {
        getRateEditEnableAndDisabled({ dateStatus: "ENABLE", id: ids }).then(
          (data) => {
            if (data.code == 200) {
              this.operationFun("success", "启用成功");
            } else {
              this.operationFun("error", "启用失败");
            }
          }
        );
      } else {
        getRateEditEnableAndDisabled({ dateStatus: "DISABLE", id: ids }).then(
          (data) => {
            if (data.code == 200) {
              this.operationFun("warning", "已禁用!");
            } else {
              this.operationFun("error", "禁用失败");
            }
          }
        );
      }
    },

    // 搜索框获得焦点
    focusFun() {
      this.inputFlag = true;
    },
    // 搜索框失去焦点
    blurFun() {
      this.inputFlag = false;
    },
    // 删除弹窗
    delOpen(ids) {
      this.$confirm("此操作将删除该模板, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let index = this.temDate.findIndex((item) => item.id == ids);
          this.temDate.splice(index, 1);
          this.operationFun("success", "删除成功");
        })
        .catch(() => {
          this.operationFun("info", "已取消删除");
        });
    },
    //新增模板
    addFun() {
      this.newAdd = false;
      this.stepNum = 1;
      this.monthTable.endMonthList = this.endMonthList;
    },
    //新增模板输入框失去焦点验证
    addNameFun() {
      if (this.addName == "") {
        this.operationFun("warning", "请输入模板名称");
        return;
      }
      if (this.rateType == "") {
        this.operationFun("warning", "请选择能源类型");
        return;
      }
      this.saveAllData.rateTemplateDTO = {
        energyType: this.rateType,
        temName: this.addName,
      };
      this.stepNum = 2;
    },

    //月区间结束月份
    endChange(index) {
      if (this.monthTable[index].endMonth == 12) {
        this.monthTable.splice(index + 1);
        this.MonValue = index + 1;
        //月区间数选项
        this.MonOpyios.forEach((item) => {
          item.disabled = true;
        });
        this.MonOpyios[index].disabled = false;
        this.stepTwo = true;
        this.preservationFun();
      } else {
        this.MonOpyios.forEach((item) => {
          item.disabled = false;
        });
      }
      //判断不是最后一行
      if (this.monthTable[index + 1]) {
        this.endMonFun(index + 1, index);
      }
    },
    // 结束月份判断操作(备份)
    endMonFun(next, per) {
      this.monthTable[next].startMonth = this.monthTable[per].endMonth + 1;
      this.endMonthList.forEach((item) => {
        if (item.num <= this.monthTable[per].endMonth) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },

    //月区间保存
    preservationFun() {
      let sectionVOSData = [];
      for (let i = 0; i < this.monthTable.length; i++) {
        sectionVOSData.push({
          endMonth: this.monthTable[i].endMonth,
          sectionName: `月区间${i + 1}`,
          sectionType: "ORDINARY",
          startMonth: this.monthTable[i].startMonth,
          weekNum: "SUNDAY",
        });
      }
      var ab = {
        sectionTotal: this.MonValue,
        sectionDTOs: sectionVOSData,
        temId: "",
      };
      this.saveAllData.rateSectionDTO = ab;
      this.keepBtn = true;
    },
    //自定义区间复选框
    weekChecked_fn(val) {
      var weekArr = [
        {
          sectionName: `自定义区间`,
          sectionType: "CUSTOMIZED",
          weekNum: "",
        },
      ];
      if (val) {
        this.saveAllData.rateSectionDTO.sectionDTOs.push(weekArr[0]);
        this.saveAllData.rateSectionDTO.sectionTotal += 1;
      } else {
        this.saveAllData.rateSectionDTO.sectionDTOs.pop();
        this.saveAllData.rateSectionDTO.sectionTotal -= 1;
      }
    },
    //自定义区间选择器
    weekSelect(val) {
      this.saveAllData.rateSectionDTO.sectionDTOs[
        this.monthTable.length
      ].weekNum = val;
    },
    //点击配置
    disposeFun(index, num) {
      // if(!this.stepTwo) {
      //    this.operationFun('warning','区间设置信息填写不完整')
      //    return
      // }
      // if(!this.configure){
      //    this.operationFun('warning','请填写完整正在配置的尖峰平谷')
      //     return
      // }
      if (num == 0) {
        this.sectionName = `自定义`;
      } else {
        this.sectionName = `月区间${index + 1}`;
      }
      this.peakIndex = index;
      this.configure = false;
      if (
        this.saveAllData.rateSectionDTO.sectionDTOs[index].hasOwnProperty(
          "rateStageDTO"
        )
      ) {
        this.peakTable = this.saveAllData.rateSectionDTO.sectionDTOs[
          index
        ].rateStageDTO.stages;
      } else {
        this.startOptions = [];
        this.endOptions = [];
        this.peakTable = [
          {
            startOptions: [],
            endOptions: [],
            rateValue: "",
            stageType: "",
            startValue: "",
            endValue: "",
            startFrame: "",
            endFrame: "",
          },
        ];
        this.getRateTimeConfigFun();

        //  this.sectionName = this.sectionData[index].sectionName
        //  this.sectionId = this.sectionData[index].id
        this.stepNum = 3;
      }
    },
    // 选择月区间数
    choiceMon() {
      let flag = this.monthTable.every((item) => item.endMonth == "");
      if (!flag) {
        let max = Math.max.apply(
          Math,
          this.monthTable.map((item) => {
            return item.endMonth;
          })
        );
        let index = this.monthTable.findIndex((item) => item.endMonth == max);

        if (max != 12) {
          this.monthTable[index + 1].startMonth = max + 1;
        } else {
          this.MonOpyios[index + 1].disabled = true;
        }
      }
    },
    //尖峰平谷系列
    //加号按钮操作
    peakBtnFun() {
      //  this.peakTable[0].endOptions.forEach(item => item.disabled = true)
      this.copyPeakTable = JSON.parse(JSON.stringify(this.peakTem[0]));
      this.peakTable.push(this.copyPeakTable);
    },
    // 获取尖峰平谷时间配置
    getRateTimeConfigFun() {
      this.startOptions = [];
      this.endOptions = [];
      getRateTimeConfig().then((data) => {
        let getData = data.data;
        //转换数据成数组格式
        for (let i in getData) {
          this.startOptions.push({
            startValue: i,
            startFrame: getData[i],
            disabled: false,
          });
          this.endOptions.push({
            endValue: i,
            endFrame: getData[i],
            disabled: true,
          });
        }
        // this.endOptions =JSON.parse(JSON.stringify(this.startOptions))
        this.endOptions.shift();
        this.startOptions.pop();
      });
    },
    //选择尖峰平谷类型
    stageTypeFun(val, index) {
      // this.rateValue

      const findIndex = this.peakTable.findIndex(
        (item) => item.stageType === val
      );

      this.peakTable[index].rateValue = this.peakTable[findIndex].rateValue;
      // let rateNum = this.peakTable[index].rateValue
      // this.peakTable.forEach(item => {
      //   if(item.stageType == val){
      //     item.rateValue = rateNum
      //   }
      // })
    },
    // 时间开始选择
    timeStarChange(index) {
      //开始删除下标
      this.startDelIndex = this.startOptions.findIndex(
        (item) => item.startValue == this.peakTable[index].startValue
      );

      this.endOptions.forEach((item) => (item.disabled = false));
      this.startTimeVal = this.peakTable[index].startValue;

      this.peakTable[index].startFrame = this.startOptions[
        this.startDelIndex
      ].startFrame;
      this.endOptions.forEach((item) => {
        if (Number(this.startTimeVal) + 1 > item.endValue) {
          item.disabled = true;
        }
      });
    },
    // 时间结束选择
    timeEndChange(index) {
      this.endDelIndex = this.endOptions.findIndex(
        (item) => item.endValue == this.peakTable[index].endValue
      );
      this.endTimeVal = this.peakTable[index].endValue;
      this.peakTable[index].endFrame = this.endOptions[
        this.endDelIndex
      ].endFrame;
      if (this.peakTable[index].endFrame == "24:00") {
        // this.configure  =true
        this.completeFun();
      }
      if (this.endDelIndex == 0) {
        this.startOptions.splice(this.startDelIndex, 1);
        this.endOptions.splice(this.startDelIndex, 1);
        return;
      }
      this.startOptions.splice(
        this.startDelIndex,
        Number(this.endDelIndex) - Number(this.startDelIndex) + 1
      );
      this.endOptions.splice(
        this.startDelIndex,
        Number(this.endDelIndex) - Number(this.startDelIndex) + 1
      );
    },
    //重置尖峰平谷
    resetFun() {
      this.$confirm("重置该区间配置操作, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.configure = true;
          // this.disposeFun(this.peakIndex,1)
          var d = [
            {
              startOptions: [],
              endOptions: [],
              rateValue: "",
              stageType: "",
              startValue: "",
              endValue: "",
              startFrame: "",
              endFrame: "",
            },
          ];
          this.saveAllData.rateSectionDTO.sectionDTOs[
            this.peakIndex
          ].rateStageDTO.stages = d;
          this.peakTable = d;
          // this.peakTable =   this.saveAllData.rateSectionDTO.sectionDTOs[this.peakTable].rateStageDTO.stages
          this.getRateTimeConfigFun();
          this.operationFun("success", `重置月区间${this.peakIndex + 1}成功`);
        })
        .catch(() => {
          this.operationFun("info", "已取消重置");
        });
    },

    //保存月区间尖峰平谷配置
    completeFun() {
      let newArr = [];
      let flag = this.peakTable.every(
        (item) =>
          item.stageType == "" ||
          item.rateValue == "" ||
          item.startValue == "" ||
          item.endValue == ""
      );

      if (flag) {
        this.operationFun("warning", "信息填写不完整");
        return;
      }

      this.peakTable.forEach((item) => {
        newArr.push({
          endFrame: item.endFrame,
          endValue: item.endValue,
          rateValue: item.rateValue,
          stageType: item.stageType,
          startFrame: item.startFrame,
          startValue: item.startValue,
        });
      });
      if (newArr.length < 3) {
        this.operationFun("warning", "必须配置峰平谷");
        return;
      }
      var Rate = {
        sectionId: "",
        stages: newArr,
      };

      this.saveAllData.rateSectionDTO.sectionDTOs[
        this.peakIndex
      ].rateStageDTO = Rate;
      // console.log("this.saveAllData.rateSectionDTO.sectionDTOs",this.saveAllData.rateSectionDTO.sectionDTOs);
      this.configure = true;
      this.operationFun("success", `${this.sectionName}配置成功`);
    },

    //完成配置
    doneFun() {
      this.maskFlag = false;
      this.newAdd = true;
      this.detailsDisable = false;
      this.peakIndex = 0;
      this.getRateDataFun(); //费率模板数据
    },
    tongyi() {
      rateSaveAll(this.saveAllData).then((data) => {
        if (data.code == 200) {
          this.maskFlag = false;
          this.newAdd = true;
          this.detailsDisable = false;
          this.peakIndex = 0;
          this.operationFun("success", `新增模板成功`);
          this.getRateDataFun(); //费率模板数据
        } else {
          this.operationFun("warning", `新增失败,${data.message}`);
        }
      });
    },

    //返回列表
    listBtnFun() {
      if (this.detailsDisable) {
        this.newAdd = true;
        this.addName = "";
        this.rateType = "";
        this.stepNum = 1;
        this.isDisabled = false;
        this.MonValue = 1;
        this.monthTable = this.monthTable2;
        this.weekData = [];
        this.detailsDisable = false;
      } else {
        this.$confirm("此操作不保存草稿，是否返回列表?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.operationFun("success", `返回成功`);
            this.newAdd = true;
            this.addName = "";
            this.rateType = "";
            this.stepNum = 1;
            this.isDisabled = false;
            this.MonValue = 1;
            this.monthTable = this.monthTable2;
            this.weekData = [];
            this.detailsDisable = false;
          })
          .catch(() => {
            this.operationFun("info", `取消返回`);
          });
      }
    },

    // 查看详情
    viewDetailsFun(id) {
      this.detailsDisable = true;
      this.newAdd = false;
      let index = this.temDate.findIndex((item) => item.id == id);
      this.addName = this.temDate[index].temName;
      this.rateType = this.temDate[index].energyType;
      // 月区间详情
      getRateFindSectionListByTemId({ temId: id }).then((data) => {
        if (data.code == 200) {
          this.stepNum = 2;
          this.weekData = data.data.filter(
            (item) => item.sectionType == "CUSTOMIZED"
          );
          if (this.weekData.length != 0) {
            this.weekChecked = true;
            this.weekNum = this.weekData[0].weekNum;
            this.monthTable = data.data;
            this.monthTable.pop();
          } else {
            this.monthTable = data.data;
          }

          this.peakIndex = 0;
          // 尖峰平谷详情
          getRateFindListBySectionId({ sectionId: this.monthTable[0].id }).then(
            (data) => {
              if (data.code == 200) {
                this.stepNum = 3;
                this.peakTable = data.data;
                for (let i = 0; i < this.peakTable.length; i++) {
                  this.peakTable[i]["rateTypeOption"] = this.rateTypeOption;
                  // this.getRateTimeConfigFun()
                  this.peakTable[i].endValue = this.peakTable[i].endFrame;
                  this.peakTable[i].startValue = this.peakTable[i].startFrame;
                }
              }
              // this.peakFlag = true
            }
          );
        }
      });
    },

    // 月区间表格点击查看详情
    seeDetails(index) {
      this.sectionName = `月区间${index + 1}`;
      this.peakIndex = index;

      getRateFindListBySectionId({ sectionId: this.monthTable[index].id }).then(
        (data) => {
          this.peakTable = data.data;
          for (let i = 0; i < this.peakTable.length; i++) {
            this.peakTable[i]["rateTypeOption"] = this.rateTypeOption;
            // this.getRateTimeConfigFun()
            this.peakTable[i].endValue = this.peakTable[i].endFrame;
            this.peakTable[i].startValue = this.peakTable[i].startFrame;
          }
        }
      );
    },

    // 自定义区间表格点击查看详情
    seeDetails2() {
      this.sectionName = `自定义`;
      this.peakIndex = this.monthTable.length;

      getRateFindListBySectionId({ sectionId: this.weekData[0].id }).then(
        (data) => {
          this.peakTable = data.data;
          for (let i = 0; i < this.peakTable.length; i++) {
            this.peakTable[i]["rateTypeOption"] = this.rateTypeOption;
            // this.getRateTimeConfigFun()
            this.peakTable[i].endValue = this.peakTable[i].endFrame;
            this.peakTable[i].startValue = this.peakTable[i].startFrame;
          }
        }
      );
    },
  },
  watch: {
    rateType(val) {
      this.saveAllData.rateTemplateDTO = {
        energyType: val,
        temName: this.addName,
      };
      this.stepNum = 2;
    },

    //显示全部
    inputCheck(val) {
      if (val) {
        this.tempName = "";
        this.getRateDataFun(); //费率模板数据
      }
    },
    // 月区间数
    MonValue(newVal, oldVal) {
      let num = newVal - oldVal;
      if (num > 0) {
        for (let i = 0; i < newVal - oldVal; i++) {
          this.copyMonth = JSON.parse(JSON.stringify(this.sectionTem[0]));
          this.copyMonth.endMonthList = this.endMonthList;
          this.monthTable.push(this.copyMonth);
        }
      } else {
        this.monthTable.splice(newVal);
      }
      //  this.endMonFun(newVal,oldVal)
      this.choiceMon();
    },
  },
  //过滤器
  filters: {
    //费率类型 ELECTRIC(电)  WATER(水) GAS(气)
    energyType(val) {
      if (val == "ELECTRIC") {
        return "电";
      } else if (val == "WATER") {
        return "水";
      } else {
        return "气";
      }
    },
    // 转换时间戳
    date_format: function(value) {
      //value就是插值的数据
      let date = new Date(value);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";

      let h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let strDate = Y + M + D + h + m + s;
      return strDate;
    },
  },
};
</script>

<style lang="scss" scoped>
.rate-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.line {
  margin: 0px 12px;
  display: inline-block;
  width: 1px;
  height: 18px;
  background-color: #e6e6e6;
}

.custom-week {
  margin-top: 15px;

  .week-con {
    height: 40px;
    display: flex;
    align-items: center;
    border: 1px solid #dcdfe6;

    .week-left {
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #dcdfe6;
      height: 40px;
    }

    .week-select {
      width: 3.2rem;
      display: flex;
      justify-content: center;

      border-right: 1px solid #dcdfe6;
    }

    .newclick {
      width: 1.2rem;
      display: flex;
      align-items: center;
      justify-content: center;

      font-size: 16px;
      color: #999999;
      font-weight: 700;
      cursor: pointer;

      img {
        margin-right: 5px;
        cursor: pointer;
      }
    }

    .active {
      color: #52a1ff;
    }
  }

  .week-top {
    display: flex;
    align-items: center;

    p {
      height: 20px;
      line-height: 22px;
      margin-right: 10px;
    }
  }
}

/deep/.el-input__suffix {
  display: flex;
  align-items: center;
}

/deep/.el-input.is-disabled .el-input__inner {
  color: #333;
}

// /deep/.el-input__inner {
//    border-top:0px ;
// }

.rate-template {
  position: relative;
  box-sizing: border-box;

  // background-color: #ffffff;
  .con {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: #fff;
    padding: 12px 20px 20px 20px;
    overflow: hidden;
  }

  //标题
  .title1 {
    height: 25px;
    width: 100px;
    color: #999;
    font-size: 18px;
    font-weight: 700;
    margin: 0px 0px 8px 0px;
    padding-left: 20px;
    padding-top: 5px;
  }

  //返回列表
  .list-btn {
    position: absolute;
    top: 5px;
    right: 20px;
    width: 88px;
    height: 26px;
    border: 1px solid #52a1ff;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: #52a1ff;
    font-size: 15px;
    cursor: pointer;
  }

  .top-search {
    display: flex;
    align-items: center;

    .add-template {
      width: 88px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      color: #fff;
      background-color: #52a1ff;
      border-radius: 5px;
      cursor: pointer;
    }

    .hide-all {
      display: flex;
      align-items: center;
      margin: 0px 40px 0px 20px;
    }
  }

  // 查询
  /deep/.search-foucs .el-input__inner {
    background-color: #e4f1ff;
    color: #000;
  }

  .search-box {
    .el-input {
      width: 350px;
    }

    /deep/.el-input__inner {
      height: 36px;
    }

    /deep/.el-input__inner:hover {
      border-color: #409eff;
    }

    /deep/.el-input-group__append {
      background-color: #409eff;
      color: #fff;
      font-size: 15px;
      border: 1px solid #409eff;
    }
  }

  .mask {
    position: absolute;
    top: 150px;
    left: 10px;
    width: 1700px;
    height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;

    .centent {
      text-align: center;
    }

    i {
      font-size: 50px;
      color: #52a1ff;
      font-weight: 700;
      margin-bottom: 10px;
    }
  }

  //模板配置 新增模板
  .tem-configure {
    margin-top: 10px;

    // 步骤条
    .steps {
      width: 13rem;
      height: 30px;
      margin-left: 1rem;
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      color: #999999;

      .circle {
        display: inline-block;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
        margin-right: 7px;
        color: #999999;
        border: 1px solid #999999;
      }

      .circle-active {
        background-color: #52a1ff;
        color: #fff;
        border: 0px;
      }

      .steps-con {
        display: flex;
        align-items: center;
        width: 95px;
        height: 30px;
        font-size: 14px;

        img {
          margin-right: 5px;
        }
      }

      .steps-color {
        color: #1a1a1a;
      }

      .steps-line {
        width: 3.4rem;
        height: 2px;
        background-color: #e6e6e6;
        margin: 0px 12px;
      }

      .steps-line-active {
        background-color: #52a1ff;
      }

      .steps-line2 {
        width: 505px;
      }

      .steps-right {
        width: 200px;
      }

      .el-steps {
        flex: 1;
      }
    }

    //具体内容
    .content {
      display: flex;

      // 左边配置名称
      .left-name {
        width: 3rem;
        height: 780px;
        padding-top: 10px;

        .main {
          width: 240px;
          height: 180px;
          margin-left: 20px;
          position: relative;

          .main-input {
            display: flex;
            align-items: center;
            font-size: 16px;

            .el-input {
              width: 160px;
              height: 30px;
            }

            /deep/.el-input__inner {
              height: 30px;
            }

            /deep/.el-input__suffix {
              display: flex;
              align-items: center;
            }
          }

          .type {
            margin-top: 40px;

            .el-select {
              width: 160px;
            }
          }

          .el-button {
            width: 88px;
            height: 36px;
            position: absolute;
            right: 0;
            bottom: 0;
          }
        }
      }

      // 中间区间设置
      .section {
        width: 6.2rem;
        height: auto;
        border-left: 2px solid #d9d9d9;
        border-right: 2px solid #d9d9d9;
        display: flex;
        justify-content: center;
        padding-top: 10px;

        .main {
          width: 5.6rem;
          padding: 0px 20px;

          .main-top {
            width: 3.7rem;
            height: 32px;
            display: flex;
            align-items: center;

            .start {
              width: 1.5rem;
              height: 24px;
              font-size: 16px;
              display: flex;
              align-items: center;

              span {
                margin-right: 6px;
              }
            }

            .num {
              width: 2rem;
              height: 30px;
              display: flex;
              align-items: center;

              // margin-left: 10px;
              .el-select {
                width: 1.2rem;
                height: 30px;
              }

              /deep/.el-input__inner {
                height: 30px !important;
              }
            }
          }

          .main-table {
            margin-top: 20px;
            text-align: center;

            .table {
              border: 1px solid #dcdfe6;
              border-collapse: collapse;
            }

            td,
            th {
              border-left: 1px solid #dcdfe6;
              border-top: 1px solid #dcdfe6;
            }

            thead {
              font-size: 16px;
              color: #999999;
              font-weight: 700;

              tr {
                background-color: #f3f8ff;
                height: 40px;
              }
            }

            tr {
              height: 40px;
            }

            /deep/.el-select,
            /deep/.el-input,
            /deep/.el-input__inner {
              border-top: 0px;
              height: 20px !important;
              border: 0px;
            }

            /deep/.el-input__inner {
              padding-left: 40px;
              font-size: 16px;
            }

            .click {
              font-size: 16px;
              color: #999999;
              font-weight: 700;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 39px;

              img {
                margin-right: 5px;
                cursor: pointer;
              }
            }

            .active {
              color: #52a1ff;
            }
          }

          .next-btn {
            position: relative;

            .el-button {
              position: absolute;
              top: 15px;
              right: 0;
              width: 88px;
              height: 36px;
            }
          }
        }
      }

      // 右边尖峰平谷设置
      .configure {
        width: 7rem;
        height: auto;
        display: flex;
        justify-content: center;
        padding-top: 10px;

        /deep/.el-input__inner {
          font-size: 16px;
          height: 20px !important;
        }

        .main {
          width: 650px;
          height: auto;

          .section-item {
            .main-name {
              margin-bottom: 20px;
            }

            .main-table {
              text-align: center;

              .table {
                border: 1px solid #dcdfe6;
                border-collapse: collapse;
              }

              td,
              th {
                border-left: 1px solid #dcdfe6;
                border-top: 1px solid #dcdfe6;
              }

              thead {
                font-size: 16px;
                color: #999999;
                font-weight: 700;

                tr {
                  background-color: #f3f8ff;
                  height: 40px;
                }
              }

              tbody {
                tr {
                  height: 40px;
                }

                .type {
                  /deep/.el-select,
                  /deep/.el-input,
                  /deep/.el-input__inner {
                    width: 100px;
                    height: 20px;
                    border: 0px;
                  }
                }

                .rate-num {
                  input {
                    width: 90px;
                    border: 0px;
                    outline: none;
                    text-align: center;
                  }
                }

                .timer {
                  padding-left: 20px;

                  /deep/.el-input__inner {
                    // width: 160px;
                    height: 25px;
                    border: 0px;
                    text-align: center;
                  }

                  /deep/.el-date-editor {
                    width: 160px;
                  }

                  /deep/.el-icon-time {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  }
                }
              }
            }
          }

          .main-btn {
            width: 6.5rem;
            height: 72px;
            position: relative;

            .complete {
              position: absolute;
              top: 0;
              right: 0;
            }

            .btn {
              position: absolute;
              bottom: 0px;
              right: 0;
              width: 72px;
              height: 51px;
              color: #fff;

              .add {
                position: absolute;
                top: -34px;
                right: -12px;
                width: 24px;
                height: 24px;
                background-color: #52a1ff;
                border-radius: 50%;
                text-align: center;
                line-height: 24px;
                font-size: 28px;
              }

              .complete {
                position: absolute;
                bottom: 20px;
                left: 0;
                width: 72px;
                height: 36px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
